<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="onCreateAssistant">{{generateCustomizeString('add')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="assistantData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="assistantListLoading">
        <el-table-column prop="id" :label="generateCustomizeString('assistantId')" width="120">
        </el-table-column>
        <el-table-column prop="username" :label="generateCustomizeString('username')">
        </el-table-column>
        <el-table-column :label="generateCustomizeString('wechatImg')" >
          <template slot-scope="scope">
            <img v-if="scope.row.headimgurl" :src="scope.row.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'" style="width:auto;height:50px;" />
          </template>
        </el-table-column>
        <el-table-column prop="wechatName" :label="generateCustomizeString('wechatName')" >
        </el-table-column>
        <el-table-column prop="phone" :label="generateCustomizeString('phone')">
        </el-table-column>
        <el-table-column prop="email" :label="generateCustomizeString('email')">
        </el-table-column>
        <el-table-column prop="roles" :label="generateCustomizeString('role')" width="260">
          <template slot-scope="scope">
            <template v-if="$i18n.locale == 'zh'">
              <el-tag
                :key="role.id"
                v-for="role in scope.row.roles"
                closable
                :disable-transitions="false"
                @close="onRemoveRole(scope.$index, role)">
                {{role.name}}
              </el-tag>
              <el-select v-if="scope.$index === onAssignIndex" v-model="selectValue" placeholder="select" @change="onChange">
                <el-option
                  v-for="(role, index) in allRoles"
                  :key="role.id"
                  :label="role.name"
                  :value="index">
                </el-option>
              </el-select>
              <div v-else>
                <el-button size="small" @click="onAssignRole(scope.$index)">{{generateCustomizeString('addRole')}}</el-button>
              </div>
            </template>
            <template v-else-if="$i18n.locale == 'en'">
              <el-tag
                :key="role.id"
                v-for="role in scope.row.roles"
                closable
                :disable-transitions="false"
                @close="onRemoveRole(scope.$index, role)">
                {{role.enName}}
              </el-tag>
              <el-select v-if="scope.$index === onAssignIndex" v-model="selectValue" placeholder="select" @change="onChange">
                <el-option
                  v-for="(role, index) in allRoles"
                  :key="role.id"
                  :label="role.enName"
                  :value="index">
                </el-option>
              </el-select>
              <div v-else>
                <el-button size="small" @click="onAssignRole(scope.$index)">{{generateCustomizeString('addRole')}}</el-button>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" :label="generateCustomizeString('createdAt')" width="160">
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onEdit(scope.$index)">{{generateCustomizeString('editAssistant')}}
            </el-button>
            <el-button type="text" size="small" @click="onRemoveAssistant(scope.$index)">{{generateCustomizeString('delete')}}
            </el-button>
            <el-dialog :title="generateCustomizeString('editAssistantDetail')" :visible.sync="updateAssistantDialogVisible" width="40%" :append-to-body="true">
              <el-form ref="form" :model="form" class="detailForm" label-width="25%">
                <div style="margin: 0 30px;">
                  <el-form-item :label="generateCustomizeString('assistantId')">
                    <el-input v-model="form.username" style="width: 90%;"></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('email')">
                    <el-input v-model="form.email" style="width: 90%;"></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('phone')">
                    <el-input v-model="form.phone" style="width: 90%;"></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('password')">
                    <el-input v-model="form.password" placeholder="**********" style="width: 56%;" disabled></el-input>
                    <el-button @click="editPassword()" style="width: 34%;">{{generateCustomizeString('editPassword') }}</el-button>
                  </el-form-item>
                  <el-form-item style="margin-top: 40px;">
                    <div>
                      <el-button @click="updateAssistantDialogVisible = false" style="width: 80px;">{{generateCustomizeString('cancel') }}</el-button>
                      <el-button type="primary" @click="editAssistant()" style="width: 80px; margin-left: 30px;">{{generateCustomizeString('confirm') }}</el-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </el-dialog>
            <el-dialog :title="generateCustomizeString('changePassword')" :visible.sync="editPasswordDialogVisible" width="30%" :append-to-body="true">
              <el-form ref="form" :model="passwordForm" class="detailForm" label-width="27%">
                <div style="margin: 0 10px;">
                  <el-form-item :label="generateCustomizeString('password')" prop="password">
                    <el-input v-model="passwordForm.password" style="width: 100%;"></el-input>
                  </el-form-item>
                  <el-form-item :label="generateCustomizeString('confirmPassword')" prop="password">
                    <el-input v-model="passwordForm.confirm_password" style="width: 100%;"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top: 40px;">
                    <div>
                      <el-button @click="editPasswordDialogVisible = false" style="width: 80px;">{{ generateCustomizeString('cancel') }}</el-button>
                      <el-button type="primary" @click="confirmEditPassword()" style="width: 80px; margin-left: 20px;">{{ generateCustomizeString('confirm') }}</el-button>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </el-dialog>
            <el-dialog title="提示" :visible.sync="removeAssistantDialogVisible" width="30%" :append-to-body="true">
              <span>{{ generateCustomizeString('confirmDelete') }}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="removeAssistantDialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
                <el-button type="primary" @click="onConfirmDeleteAssistant()">{{ generateCustomizeString('confirm') }}</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'AssistantCenter',
  data() {
    return {
      assistantData: [],
      assistantWechatData: [],
      assistantListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      allRoles: [],
      onAssignIndex: null,
      fetchRolesLoading: false,
      selectValue: '',
      removeAssistantDialogVisible: false,
      removeAssistantId: null,
      editAssistantId: null,
      updateAssistantDialogVisible: false,
      editPasswordDialogVisible: false,
      form: {
        username: '',
        email: '',
        phone: '',
        password: ''
      },
      passwordForm: {
        password: '',
        confirm_password: ''
      }
    }
  },
  methods: {
    generateCustomizeString,
    onRemoveAssistant(index) {
      this.removeAssistantDialogVisible = true
      this.removeAssistantId = this.assistantData[index].id
    },
    onEdit(index) {
      this.updateAssistantDialogVisible = true
      this.editAssistantId = this.assistantData[index].id
      this.form.username = this.assistantData[index].username
      this.form.email = this.assistantData[index].email
      this.form.phone = this.assistantData[index].phone
    },
    editPassword() {
      // this.updateAssistantDialogVisible = false
      this.editPasswordDialogVisible = true
    },
    confirmEditPassword() {
      if (this.passwordForm.password && this.passwordForm.confirm_password) {
        if (this.passwordForm.password === this.passwordForm.confirm_password) {
          request({
            url: 'admin/assistant/' + this.editAssistantId,
            method: 'patch',
            data: {
              password: this.passwordForm.password,
              confirm_password: this.passwordForm.confirm_password
            }
          }).then(response => {
            this.fetchAssistantData()
          }).catch(error => {
            console.warn(error)
          }).finally(() => {
            this.passwordForm.password = ''
            this.passwordForm.confirm_password = ''
            this.editPasswordDialogVisible = false
            this.updateAssistantDialogVisible = false
          })
        } else {
          this.$message.error(this.generateCustomizeString('passwordUnmatch'))
        }
      } else {
        this.$message.error(this.generateCustomizeString('passwordCanNotBeEmpty'))
      }
    },
    onConfirmDeleteAssistant() {
      if (this.removeAssistantId >= 0) {
        this.fetchRemoveAssistant(this.removeAssistantId)
      }
    },
    // 赋予角色选择
    onChange(index) {
      const role = this.allRoles[index]
      const assistant = this.assistantData[this.onAssignIndex]
      for (const i in assistant.roles) {
        const r = assistant.roles[i]
        if (r.id === role.id) {
          this.$message.error(this.generateCustomizeString('RoleDuplicate'))
          this.selectValue = ''
          return
        }
      }
      this.fetchAssignRole(assistant.id, role.id)
    },
    onAssignRole(index) {
      this.fetchRoles()
      this.onAssignIndex = index
    },
    onRemoveRole(index, role) {
      console.log(index, role)
      const assistant = this.assistantData[index]
      this.fetchRemoveRole(assistant.id, role.id)
    },
    onRefersh() {
      this.fetchAssistantData(this.currentPage)
    },
    onCreateAssistant() {
      this.$router.push({ name: 'CreateAssistant' })
    },
    handleCurrentChange(val) {
      this.fetchAssistantData(val)
    },
    editAssistant() {
      request({
        url: 'admin/assistant/' + this.editAssistantId,
        method: 'patch',
        data: {
          username: this.form.username,
          email: this.form.email,
          phone: this.form.phone
        }
      }).then(response => {
        this.fetchAssistantData()
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.updateAssistantDialogVisible = false
      })
    },
    fetchRemoveAssistant(assistantId) {
      if (this.assistantListLoading) return
      this.assistantListLoading = true
      request({
        url: 'admin/assistant/remove',
        method: 'post',
        data: {
          assistant_id: assistantId
        }
      }).then(response => {
        console.info('assistant remove success', response)
        this.removeAssistantId = null
        this.removeAssistantDialogVisible = false
        this.$message.success(this.generateCustomizeString('deletedSuccessfully'))
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.assistantListLoading = false
        this.fetchAssistantData(1)
      })
    },
    fetchAssignRole(userId, roleId) {
      if (this.fetchRolesLoading) return
      this.fetchRolesLoading = true
      request({
        url: 'permission/user/role/assign',
        method: 'post',
        data: {
          user_id: userId,
          role_id: roleId
        }
      }).then(response => {
        console.info('role assign success', response)
        this.$message.success(this.generateCustomizeString('updateSuccessfully'))
        this.selectValue = ''
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.fetchRolesLoading = false
        this.onAssignIndex = null
        this.fetchAssistantData(1)
      })
    },
    fetchRemoveRole(userId, roleId) {
      if (this.fetchRolesLoading) return
      this.fetchRolesLoading = true
      request({
        url: 'permission/user/role/remove',
        method: 'post',
        data: {
          user_id: userId,
          role_id: roleId
        }
      }).then(response => {
        console.info('role remove success', response)
        this.$message.success(this.generateCustomizeString('deletedSuccessfully'))
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.fetchRolesLoading = false
        this.fetchAssistantData(1)
      })
    },
    fetchRoles() {
      if (this.fetchRolesLoading) return
      this.fetchRolesLoading = true
      request({
        url: 'permission/role/list',
        method: 'get'
      }).then(response => {
        this.allRoles = response.data
        this.getRoleEnName(this.allRoles)
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.fetchRolesLoading = false
      })
    },
    fetchAssistantData(page) {
      if (this.assistantListLoading) return
      this.assistantListLoading = true
      request({
        url: 'admin/assistant/list',
        method: 'get',
        params: {
          page: page
        }
      }).then(response => {
        const data = response.data
        const meta = response.meta
        const assistants = data.map(obj => {
          obj.createdAt = obj.created_at.replace(/-/g, '/')
          obj.createdAt = dayjs(new Date(obj.createdAt + ' UTC')).format('YYYY-M-D HH:mm:ss')
          if (obj.wechat_auth && obj.wechat_auth.user_info) {
            obj.headimgurl = obj.wechat_auth.user_info['headimgurl']
            obj.wechatName = obj.wechat_auth.user_info['nickname']
          } else {
            obj.wechatName = 'N.A'
            obj.headimgurl = ''
          }
          return obj
        })
        this.assistantData = assistants
        for (var i = 0; i < this.assistantData.length; i++) {
          this.getRoleEnName(this.assistantData[i].roles)
        }
        this.currentPage = meta.current_page
        this.currentTotal = meta.total
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.assistantListLoading = false
      })
    },
    getRoleEnName(data) {
      for (var i = 0; i < data.length; i++) {
        switch (data[i].name) {
          case '订单管理员':
            data[i].enName = this.generateCustomizeString('订单管理员')
            break
          case '商品管理员':
            data[i].enName = this.generateCustomizeString('商品管理员')
            break
          case '仓储中心查询':
            data[i].enName = this.generateCustomizeString('仓储中心查询')
            break
          case '内容管理':
            data[i].enName = this.generateCustomizeString('内容管理')
            break
          case '店铺基础信息管理员':
            data[i].enName = this.generateCustomizeString('店铺基础信息管理员')
            break
          case '会员管理员(无余额）':
            data[i].enName = this.generateCustomizeString('会员管理员(无余额）')
            break
          case '店员权限管理':
            data[i].enName = this.generateCustomizeString('店员权限管理')
            break
          case '订单查询':
            data[i].enName = this.generateCustomizeString('订单查询')
            break
          case '物流管理员':
            data[i].enName = this.generateCustomizeString('物流管理员')
            break
          case '代理管理':
            data[i].enName = this.generateCustomizeString('代理管理')
            break
          case '优惠券管理':
            data[i].enName = this.generateCustomizeString('优惠券管理')
            break
          case '会员管理员(余额）':
            data[i].enName = this.generateCustomizeString('会员管理员(余额）')
            break
          case '交易查询':
            data[i].enName = this.generateCustomizeString('交易查询')
            break
          default:
            data[i].enName = data[i].name
        }
      }
    }
  },
  created() {
    this.fetchAssistantData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
</style>
